<template>
  <nav class="nav nav--nuttrema-menubar">
    <div class="nav-left">
      <slot name="left"></slot>
    </div>
    <div class="nav-center">
      <slot name="center"></slot>
    </div>
    <div class="nav-right">
      <slot name="right"></slot>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'nuttrema-menubar',
};
</script>

<style lang="scss" scoped>
@import "~styles/theme/colors";

.nav--nuttrema-menubar {
  margin: 0 5px;
  min-height: 3rem;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background-color: $menubar-bg;
  border: 1px solid $border-color;
  border-bottom: 2px solid $menubar-bb;

  .nav-item {
    .sub-title {
      text-transform: uppercase;
      font-weight: 800;
      color: darken($turquoise, 10%);
      text-shadow: 0 1px 0 rgba(255,255,255,0.5);
    }

    a.toggle-sidebar {
      color: darken($turquoise, 10%);
      text-shadow: 0 1px 0 rgba(255,255,255,0.5);
      &:hover, &:focus {
        color: darken($turquoise, 20%);
      }
    }
  }

}

.nav--nuttrema-menubar--east {
  margin: 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/ui/panels/nuttrema-menubar.vue